import auditors from './auditors';
import courses from './courses';
import plan from './plan';
import purchaserSettings from './purchaser-settings';
import purchaserSyncDetails from './purchaser-sync-details';
import purchasers from './purchasers';
import schoolSyncProgresses from './school-sync-progresses';
import schoolSyncStatistics from './school-sync-statistics';
import signInQrExportJobStatuses from './sign-in-qr-export-job-statuses';
import students from './students';
import syncClasses from './sync-classes';
import syncGroups from './sync-groups';
import syncUsers from './sync-users';
import teachers from './teachers';
import users from './users';

export default {
  purchaserSettings,
  purchaserSyncDetails,
  purchasers,
  auditors,
  courses,
  plans: plan,
  schoolSyncProgresses,
  schoolSyncStatistics,
  signInQrExportJobStatuses,
  students,
  syncClasses,
  syncGroups,
  syncUsers,
  teachers,
  users,
};
